import React from 'react';
import { css } from '../../../customEmotion';

import { useMUITheme } from '../../styles/theme';

interface GreyBlockProps {
  text: string;
}

const GreyBlock: React.FC<GreyBlockProps> = ({ text }) => {
  const theme = useMUITheme();
  return (
    <div
      className={css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30px;
        padding: 0 8px;
        background: ${theme.palette.grey['100']};
        border-radius: 4px;
        margin-right: 4px;
        color: ${theme.palette.text.secondary};
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        align-self: center;

        &:last-of-type {
          margin-right: 0;
        }
      `}
    >
      {text}
    </div>
  );
};

export default GreyBlock;
